import { createAsyncThunk } from '@reduxjs/toolkit';

import { Dependencies, RootState } from '@/redux/create-store';
import { AppDispatch } from '@/redux/index';
import { UntypedObject } from '@/types';

export const createAppAsyncThunk =
   createAsyncThunk.withTypes<({
    state: RootState;
    dispatch: AppDispatch;
    extra: Dependencies;
    rejectValue: UntypedObject
  })>();
